interface ICourseAccess {
  course_page_access: string;
  has_enrollment: boolean;
}

export function checkUserHasAccess(course: ICourseAccess, user: any) {
  switch (course?.course_page_access) {
    case "all_logged_users":
      if (user) return true;
      break;

    case "only_enrolled_users":
      if (course?.has_enrollment) return true;
      break;

    default:
      return true;
  }
}
